import { useCallback, useState } from 'react';
import { memo } from 'react';
import { PersonAdd } from '@mui/icons-material';
import { Link } from '@mui/material';
import clsx from 'clsx';

import PortalUserDisplay from 'pages/common/portal/portal-user-display';
import PortalUsersAutocomplete, {
  UserAutoCompleteOption,
} from 'pages/common/portal/portal-users-autocomplete';

import { useStyles } from './deadline-tracker-point-person.styles';

type DeadlineTrackerPointPersonProps = {
  assignedUserId?: string | null;
  portalId: string;
  onAssignedUserChange: (assignedUserId: string | null) => void;
};

export const DeadlineTrackerPointPerson = memo(
  ({ assignedUserId, portalId, onAssignedUserChange }: DeadlineTrackerPointPersonProps) => {
    const [isEditingPointPerson, setIsEditingPointPerson] = useState(false);
    const classes = useStyles();

    const handleAssignedUserChange = useCallback(
      (
        _elementId: string,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        _e: any,
        option: UserAutoCompleteOption | null,
      ) => {
        const assignedUserId = option?.id || null;
        onAssignedUserChange(assignedUserId);
        setIsEditingPointPerson(false);
      },
      [onAssignedUserChange],
    );

    if (isEditingPointPerson) {
      return (
        <PortalUsersAutocomplete
          elementId={'assignedUserId_' + assignedUserId}
          portalId={portalId}
          selectedUserId={assignedUserId || undefined}
          handleUserChange={handleAssignedUserChange}
          handleLoseFocus={() => {
            setIsEditingPointPerson(false);
          }}
          openByDefault={true}
        />
      );
    }
    if (assignedUserId) {
      return (
        <Link className={classes.pointPersonLink} onClick={() => setIsEditingPointPerson(true)}>
          <PortalUserDisplay userId={assignedUserId} />
        </Link>
      );
    }

    return (
      <Link
        className={clsx(classes.link, classes.addTeamMemberLink)}
        onClick={() => setIsEditingPointPerson(true)}
      >
        <PersonAdd />
      </Link>
    );
  },
);
